import { proxy } from 'valtio';

const viewportSizeState = proxy({
    width: 0,
    height: 0,
});

export { viewportSizeState };
